import { render, staticRenderFns } from "./PBXControl.vue?vue&type=template&id=4df345d8"
import script from "./PBXControl.vue?vue&type=script&lang=js"
export * from "./PBXControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports